export default __webpack_public_path__ + "90acaef.png";